import { useEffect } from "react";
import { useMatches } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APP_NAME } from "@/constants/config";

/**
 * Component that manages the document title based on the current route.
 */
export const TitleManager = () => {
  const matches = useMatches();
  const { t } = useTranslation();

  // Find the deepest match that has a title in its handle
  const furthestMatch = [...matches]
    .reverse()
    .find((m) => (m.handle as { title?: string })?.title);
  const titleKey = (furthestMatch?.handle as { title?: string })?.title;

  const translatedTitle = titleKey ? t(titleKey) : "";
  const fullTitle = translatedTitle
    ? `${translatedTitle} | ${APP_NAME}`
    : APP_NAME;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return null;
};
